// @ts-expect-error - TS7016 - Could not find a declaration file for module 'd3-color'. '/Users/tylerkrupicka/stripe/pay-server/frontend/sail/node_modules/d3-color/dist/d3-color.js' implicitly has an 'any' type.
import { hcl, rgb } from 'd3-color'; // @ts-expect-error - TS7016 - Could not find a declaration file for module 'd3-interpolate'. '/Users/tylerkrupicka/stripe/pay-server/frontend/sail/node_modules/d3-interpolate/dist/d3-interpolate.js' implicitly has an 'any' type.

import { interpolateHcl } from 'd3-interpolate';
import { findEdge } from "../math";
export const interpolate = (a, b) => {
  return interpolateHcl(a, b);
};
export const toRgb = str => {
  return rgb(str);
};
export const toHex = str => {
  return rgb(str).hex();
};
export const toHcl = str => {
  return hcl(str);
};
export const setOpacity = (str, opacity) => {
  const color = toRgb(str);
  color.opacity = opacity;
  return color;
};
export const isColorDisplayable = str => {
  return rgb(str).displayable();
}; // Reduces a color’s chroma until it is displayable and satisfies an optional
// condition.

export const clipChroma = (str, predicate) => {
  const color = hcl(str);
  const chroma = findEdge(color.c, 0, c => {
    color.c = c;
    return color.displayable() && (!predicate || predicate(color));
  }, 1);
  color.c = chroma;
  return color;
}; // Used to transform a translucent color into an opaque color.
// Returns the resulting color when a foreground color is displayed atop
// the background color.

export const compositeAlpha = (foreground, background = 'white') => {
  const fg = toRgb(foreground);

  if (fg.opacity === 1) {
    return fg;
  }

  let bg = toRgb(background); // If the background is translucent, composite it over white.

  if (bg.opacity !== 1) {
    bg = compositeAlpha(bg);
  }

  if (fg.opacity === 0) {
    return bg;
  } // https://en.wikipedia.org/wiki/Alpha_compositing


  const {
    opacity
  } = fg;
  const r = opacity * fg.r + (1 - opacity) * bg.r;
  const g = opacity * fg.g + (1 - opacity) * bg.g;
  const b = opacity * fg.b + (1 - opacity) * bg.b;
  return rgb(r, g, b);
}; // Used to transform a opaque color into a translucent color.
// Returns a foreground color with the provided opacity that matches the
// provided composite color when displayed atop the background color.
//
// NOTE: This could result in an imaginary color.

export const decompositeAlpha = (opacity, composite, background = 'white') => {
  const comp = toRgb(composite);

  if (opacity === 1) {
    return comp;
  }

  let bg = toRgb(background); // If the background is translucent, composite it over white.

  if (bg.opacity !== 1) {
    bg = compositeAlpha(bg);
  }

  if (opacity === 0) {
    return bg;
  } // https://en.wikipedia.org/wiki/Alpha_compositing
  // Solve for the foreground channel:


  const r = (comp.r - (1 - opacity) * bg.r) / opacity;
  const g = (comp.g - (1 - opacity) * bg.g) / opacity;
  const b = (comp.b - (1 - opacity) * bg.b) / opacity;
  return rgb(r, g, b, opacity);
};